import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';

function Information({ data }) {
  return (
    <div className="p-3">
      <table className="transaction-table table table-striped table-borderless table-sm">
        <tbody>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              <b>SOA Number / Order Payment No. / OVR No.</b>
            </td>
            <td colSpan={4}>
              <b>{get(data, 'included.module.attributes.soa_number') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              <b>SOA Number / Order Payment No. / OVR No. Date</b>
            </td>
            <td colSpan={4}>
              <b>{get(data, 'included.module.attributes.soa_date') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              <b>Amount</b>
            </td>
            <td colSpan={4}>
              <b>{`PHP ${get(data, 'attributes.amount') || '0'}`}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              <b>Remarks</b>
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.remarks') || '-'}</b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white" colSpan={12}>
              <hr />
            </td>
          </tr>
          <tr>
            <td
              className="cms-text-primary cms-bg-color-primary-light"
              colSpan={12}
            >
              <b>Account Name</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              <b>Last Name</b>
            </td>
            <td colSpan={4}>
              <b>
                {get(data, 'included.taxPayer.attributes.last_name') || '-'}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              <b>First Name</b>
            </td>
            <td colSpan={4}>
              <b>
                {get(data, 'included.taxPayer.attributes.first_name') || '-'}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              <b>Middle Name</b>
            </td>
            <td colSpan={4}>
              <b>
                {get(data, 'included.taxPayer.attributes.middle_name') || '-'}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              <b>Suffix</b>
            </td>
            <td colSpan={4}>
              <b>
                {get(data, 'included.taxPayer.attributes.extension_name') ||
                  '-'}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              Date of Birth
            </td>
            <td colSpan={4}>
              <b>
                {moment(
                  get(data, 'included.taxPayer.attributes.birth_date')
                ).format('YYYY-MM-DD HH:mm') || '-'}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              <b>Gender</b>
            </td>
            <td colSpan={4}>
              <b>{get(data, 'included.taxPayer.attributes.gender') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              <b>Civil Status</b>
            </td>
            <td colSpan={4}>
              <b>
                {get(data, 'included.taxPayer.attributes.civil_status') || '-'}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              <b>Email</b>
            </td>
            <td colSpan={4}>
              <b>
                {get(data, 'included.taxPayer.attributes.first_name') || '-'}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              <b>Mobile No.</b>
            </td>
            <td colSpan={4}>
              <b>
                {`+63 ${get(data, 'included.taxPayer.attributes.mobile_number')
                  ? get(
                    data,
                    'included.taxPayer.attributes.mobile_number'
                  ).substring(2)
                  : ''
                  }`}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              <b>Telephone No.</b>
            </td>
            <td colSpan={4}>
              <b>
                {get(data, 'included.taxPayer.attributes.telephone_number') ||
                  '-'}
              </b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white">
              <br />
            </td>
          </tr>
          <tr>
            <td
              className="cms-text-primary cms-bg-color-primary-light"
              colSpan={12}
            >
              <b>Residential Address</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              <b>Region</b>
            </td>
            <td colSpan={4}>
              <b>
                {get(data, 'included.taxPayer.attributes.region_name') || '-'}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              <b>Province</b>
            </td>
            <td colSpan={4}>
              <b>
                {get(data, 'included.taxPayer.attributes.province_name') || '-'}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              <b>City/Municipality</b>
            </td>
            <td colSpan={4}>
              <b>
                {get(data, 'included.taxPayer.attributes.municipality_name') ||
                  '-'}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              <b>ZIP Code</b>
            </td>
            <td colSpan={4}>
              <b>{get(data, 'included.taxPayer.attributes.zip_code') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              <b>Barangay</b>
            </td>
            <td colSpan={4}>
              <b>
                {get(data, 'included.taxPayer.attributes.barangay_name') || '-'}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" colSpan={8}>
              <b>Street</b>
            </td>
            <td colSpan={4}>
              <b>{get(data, 'included.taxPayer.attributes.street') || '-'}</b>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

Information.defaultProps = {
  data: {},
};

Information.propTypes = {
  data: PropTypes.instanceOf(Object),
};

export default Information;
